
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private dayTypes! : any;

  get formData() {
    return ReservationItemModule.form;
  }
}
